export default __webpack_public_path__ + "static/media/blog_post_hero.8cb768bd.png";